import { ProgramsListParams } from "../utils";
import axiosClient from "../../../../system/helpers/axiosConfig";

export const getProgramsList = (params: ProgramsListParams) => {
  return axiosClient
    .get("api/admin/programs/list", { params })
    .then((r) => r.data);
};
